import script from "./Chapter10MasterData.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter10MasterData.vue?vue&type=script&setup=true&lang=js"

import "./Chapter10MasterData.vue?vue&type=style&index=0&id=7b45f61e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b45f61e"]])

export default __exports__